<template lang="pug">
	.cte-sector-card-container(@click="$emit('click')")
		.logo
			img(v-if="sector.iconURL" :src="sector.iconURL")
		p.title {{ sector.name }}
		p.subtitle Learn More

		.hover-bar(v-if='isAdmin')
			.btns
				.btn-float.trash(
				)
				.btn-float.edit(
					@click.stop.prevent="$emit('editClick')"
				)
					img(src='/img/edit.svg')


</template>

<script>
export default {
  name  : 'cte-sector-card',
  props : {
    sector : Object,
  },
  computed : {
    isAdmin() {
	  return this.$store.state.isAdmin;
    },
  },
};
</script>

<style lang="scss" scoped>
.cte-sector-card-container {
	padding: 15px;
	border-radius: 10px;
	box-shadow: $floatingObject;
	background: white;
	cursor: pointer;
	min-height: 250px;
	display: flex;
	flex-direction: column;
	flex: 1 1 0;
	transform: scale(1, 1);
	transition: transform 0.2s ease;

	&:active {
		transform: scale(0.9, 0.9);
	}

	.logo {
		margin: 15px;
		align-self: center;
		height: 100px;
		width: 100px;
		margin-bottom: 30px;
		border-radius: 50%;
		overflow: hidden;

		img {
			width: 100%;
			max-width: 250px;
		}
	}

	.title {
		flex: 1 0 auto;
		font-size: 18px;
		text-align: center;
	}

	.subtitle {
		font-size: 12px;
		text-transform: uppercase;
		color: $primary;
		letter-spacing: 5px;
		margin-top: 15px;
		flex: 0 0 auto;
		line-height: 150%;
		text-align: center;
	}

	&:hover {
		.hover-bar {
			opacity: 1;
			pointer-events: all;

			.btns {
				transform: translateY(0);
			}
			.sector:active ~ .hover-bar {
				transform: scale(0.9, 0.9) translateY(10px);
			}
		}
	}
	.hover-bar {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		display: flex;
		flex-direction: column;
		opacity: 0;
		transition: opacity 0.2s ease, transform 0.2s ease;
		z-index: 10;
		pointer-events: none;
		transform: scale(1, 1);
		transition: transform 0.2s ease;

		.btns {
			width: 100%;
			display: flex;
			flex-flow: row-reverse;
			justify-content: space-between;
			transform: translateY(-40px);
			transition: transform 0.2s ease;
			align-items: flex-start;
			overflow: hidden;

			.btn-float {
				padding: 0 20px;
				height: 50px;
				margin: 10px;
				border-radius: 25px;
				background: $lightGrey;
				box-shadow: $floatingObject;
				display: flex;
				align-items: center;
				justify-content: center;
				transition: box-shadow 0.2s ease;
				position: relative;
				cursor: pointer;
				pointer-events: all;

				&:active {
					box-shadow: none;
				}

				&.edit {
					background-color: #c8d1e8;
				}

				&.trash {
					opacity: 0;
					&::before {
						content: "click again to delete";
						font-size: 12px;
						color: white;
						text-transform: uppercase;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: hidden;
						max-width: 0;
						max-height: 0;
						margin-bottom: 2px;
						transition: max-width 0.2s ease;
					}

					&.confirm {
						img {
							display: none;
						}

						&::before {
							max-width: 300px;
							max-height: none;
						}
					}
				}
			}
		}
	}
}
</style>
